import React, { Component } from 'react'
import TodoInput from './components/TodoInput'
import TodoList from './components/TodoList'


import "bootstrap/dist/css/bootstrap.min.css"
import {v4 as uuid} from 'uuid'

class App extends Component{
  
    state = {
       items: [],
       id : uuid(),
       item:'',
       editItem: false
    }

    handleChange = (e) =>{
      this.setState({
        item: e.target.value
      })
    }

    handleSubmit =(e) =>{
      e.preventDefault();
      const newItem ={
        id: this.state.id,
        item: this.state.item
      } 
      console.log(newItem);
      // const updatedItems = prevState.items.push(newItem) not working
      const updatedItems = [...this.state.items,newItem];
      this.setState({
          items: updatedItems,
          item:'',
          id : uuid(),
          editItem:false
        }
      )
    }

    clearList = () =>{
      this.setState({
        items: []
      })
    }
    
    //below method is passed via props drilling
    handleDelete = (id) =>{
      const filteredItems = this.state.items.filter(item =>
          item.id !== id
        )
        this.setState({
          items: filteredItems
        })
    }
        
    //below method is passed via props drilling
    handleEdit = (id) =>{
      if(!this.state.editItem){
      const filteredItems = this.state.items.filter(item =>
        item.id !== id
      )

      const selectedItem = this.state.items.find(item => item.id===id)
      console.log(selectedItem);

      this.setState({
        items: filteredItems,
        item: selectedItem.item,
        editItem: true,
        id:id  
      })
    }else{
      alert(`can't edit two items at the same time!`)
    }
    }
  
  render(){
    return (
      <div className="container">
        <div className="row">
          <div className="col-10 mx-auto col-md-8 mt-4">
          <h3 className="text-capitalize text-center">Todo input</h3>
          <TodoInput item={this.state.item} handleChange={this.handleChange} handleSubmit={this.handleSubmit} editItem={this.state.editItem}/>
          <TodoList items={this.state.items} clearList={this.clearList} handleDelete={this.handleDelete} handleEdit={this.handleEdit}/>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
